import {
    AllData,
    Department,
    Floor,
    NavPoint,
    NavEdge,
    OfficeUtility,
    Person,
    Room,
    Seat,
    Team,
} from "@office-map/api-schema";
import { debounce } from "es-toolkit/function";
import { ReactNode, useEffect, useState } from "react";

import { Loading } from "@/components/Loading";
import { config } from "@/config";
import { fetchWithAuth, loadAccessToken } from "@/features/auth/auth.utils";

export const departments: Department[] = [];
export const teams: Team[] = [];
export const people: Person[] = [];

export const floors: Floor[] = [];
export const rooms: Room[] = [];
export const seats: Seat[] = [];

export const navPoints: NavPoint[] = [];
export const navEdges: NavEdge[] = [];
export const officeUtilities: OfficeUtility[] = [];

export const commit = () => {
    const data: AllData = {
        organization: {
            departments,
            teams,
            people,
        },
        physical: {
            floors,
            rooms,
            seats,
            navPoints,
            navEdges,
            officeUtilities,
        },
    };

    fetchWithAuth(`${config.API_BASE_URL}office-map`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
};

export const commitDebounced = debounce(commit, 500);

export const DataProvider = ({ children }: { children: ReactNode }) => {
    const [dataFetched, setDataFetched] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (dataFetched) {
                return;
            }

            // HACK: Wait until we have an access token.
            const accessToken = loadAccessToken();
            if (!accessToken) {
                setTimeout(fetchData, 100);
                return;
            }

            const response = await fetchWithAuth(`${config.API_BASE_URL}office-map`);
            const data: AllData = await response.json();

            departments.splice(0, departments.length, ...data.organization.departments);
            teams.splice(0, teams.length, ...data.organization.teams);
            people.splice(0, people.length, ...data.organization.people);

            floors.splice(0, floors.length, ...data.physical.floors);
            rooms.splice(0, rooms.length, ...data.physical.rooms);
            seats.splice(0, seats.length, ...data.physical.seats);
            navPoints.splice(0, navPoints.length, ...data.physical.navPoints);
            navEdges.splice(0, navEdges.length, ...data.physical.navEdges);
            officeUtilities.splice(0, officeUtilities.length, ...data.physical.officeUtilities);

            setDataFetched(true);
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!dataFetched) {
        return <Loading />;
    }

    return children;
};
